import React, { useCallback, useEffect, useRef, useState } from "react";
import "./SelectSongBook.scss";
import { IoCloseCircleOutline, IoSearchOutline } from "react-icons/io5";
import RestClient from "../../../@core/restClient";
import { Songbook } from "../../../@core/models";
import Spinner from "../UI/Spinner";

const SelectSongBook = (props: any) => {
  const [songBookListMy, setSongBookListMy]: any = useState([]);
  const [songBookListColl, setSongBookListColl]: any = useState([]);
  const [inputValue, setInputValue]: any = useState("");
  const [bookId, setBookId]: any = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("User") || "{}")?.id || ""
  );

  useEffect(() => {
    if (props.mainSongbook.title !== "") {
      setInputValue(props.mainSongbook.title);
    }
  }, [props.mainSongbook]);

  // INITIAL SONGBOOKS QUERY

  useEffect(function () {
    (async () => {
      try {
        const mybooks = await RestClient.getSongBooks(Number(user));
        const collbooks = await RestClient.getSongBooksCollaborators(
          Number(user)
        );
        setSongBookListMy([...mybooks]);
        setSongBookListColl([...collbooks]);
        // setSongBookList([
        //   ...mybooks,
        //   ...collbooks,
        //   ...(props.MainSongbook ? props.MainSongbook : [])
        // ]);
      } catch (error) {
        console.log(error);
      }
    })();
    setIsLoading(false);
  }, []);

  const selectSongbook = (songbook: Songbook) => {
    setInputValue(songbook.title);
    setBookId(songbook.id);
    setSelectOpen(false);
  };

  useEffect(() => {
    if (bookId === null) {
      return;
    }
    props.passBookId(bookId);
  }, [bookId]);

  const openBox = (e: any) => {
    e.stopPropagation();
    setSelectOpen(true);
  };
  const closeBox = () => {
    setSelectOpen(false);
  };
  useEffect(() => {
    if (selectOpen) {
      document.body.addEventListener("click", () => {
        setSelectOpen(false);
      });
    } else {
      return;
    }
  }, [selectOpen]);

  return (
    <div className="select">
      {isLoading ? <Spinner /> : ""}
      <input
        className="select-input"
        defaultValue={inputValue}
        onClick={(e) => openBox(e)}
        readOnly
      />
      <IoSearchOutline className="select-search" />
      <div className={`select-box  ${selectOpen ? "visable" : ""}`}>
        <IoCloseCircleOutline
          className="select-close"
          onClick={() => {
            closeBox();
          }}
        />
        {songBookListMy.map((songbook: Songbook, index: number) => (
          <div
            className="select-box-item"
            key={index}
            onClick={() => selectSongbook(songbook)}
          >
            {songbook.title}
          </div>
        ))}
        {songBookListColl.map((songbook: Songbook, index: number) => (
          <div
            className="select-box-item"
            key={index}
            onClick={() => selectSongbook(songbook)}
          >
            {songbook.title}
          </div>
        ))}
        <div
          className="select-box-item"
          onClick={() => selectSongbook(props.mainSongbook)}
        >
          {props.mainSongbook.title}
        </div>
      </div>
    </div>
  );
};

export default SelectSongBook;
